import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { MetricTooltipProps } from "../types/competitive-analysis";

export const MetricTooltip = ({ label, description }: MetricTooltipProps) => (
  <TooltipProvider delayDuration={0}>
    <Tooltip>
      <TooltipTrigger>
        <HelpCircle className="h-4 w-4" />
      </TooltipTrigger>
      <TooltipContent 
        className="max-w-[200px] bg-white" 
        side="right" 
        avoidCollisions={true}
      >
        <p>{description}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);